var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.35 4.57001L3.94995 11.77V20.64C3.94995 20.92 4.17995 21.14 4.44995 21.14H10.67V16.63C10.67 16.04 11.15 15.57 11.73 15.57H13.03C13.61 15.57 14.09 16.04 14.09 16.63V21.14H20.25C20.52 21.14 20.75 20.92 20.75 20.64V11.77L12.35 4.57001Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6b58aa7e8e542cf2acb48c9cc947b7a8.svg";
export { ForwardRef as ReactComponent };